import { PAGE_NAME } from './types'

export const setPageName = (status) => ({
  type: PAGE_NAME,
  payload: status,
})
